import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import * as dynamicEc from '../ec'
import type { Feature } from '../feature'

/**
 * Effect to handle disposal of dynamic {@link dynamicEc.Collection} instances.
 */
export const onDispose = store.effects.create((feature: Feature) =>
  feature.actions.dispose.observe().pipe(
    rxjs.map(({ data: { ref, all } }) => {
      // When `all` flag is true, dispose every dynamic Entity Collection
      const instances = all
        ? ec.Collection.instances.find<dynamicEc.Name>({
            // we use `dynamicEc.Name.isName` to ensure we only target dynamic ECs
            isName: dynamicEc.Name.isName,
          }).collections
        : // If `ref` is provided, we dispose only the ECs matching that reference
          ref
          ? ec.Collection.instances.find({
              names: [dynamicEc.Name.from(ref)],
            }).collections
          : []

      for (const collection of instances) {
        collection.destroy('onDispose (effect)')
      }

      return store.effects.SKIP
    }),
  ),
)
